const staticSearches = (state) => state.staticSearches;
const favoriteStaticSearches = (state) => state.favoriteStaticSearches;
const hasFavoriteStaticSearches = (state) => Object.keys(state.favoriteStaticSearches).length > 0;

const findStaticSearchesByKey = (context) => (key) => context.staticSearches[key];
const findFavoriteStaticSearchesByKey = (context) => (key) => context.favoriteStaticSearches[key];

const activeWorkCollapsePanels = (context) => {
  if (localStorage.getItem("dashboard-work-active-collapse-panels") !== null) {
    return JSON.parse(localStorage.getItem("dashboard-work-active-collapse-panels"));
  }
  return context.activeWorkCollapsePanels;
};

export default {
  staticSearches,
  favoriteStaticSearches,
  hasFavoriteStaticSearches,
  findStaticSearchesByKey,
  findFavoriteStaticSearchesByKey,
  activeWorkCollapsePanels,
};
